import React, { useEffect, useState } from "react";
import { useClickAway, useWindowSize } from "react-use";

import usePortal from "../../../hooks/usePortal";

const PICKER_WIDTH = 246;

const PickerModal = ({
  onConfirm,
  pickerVisible,
  pickerContainerRef,
  setPickerVisible,
  showPicker,
  children,
}) => {
  const PickerPortal = usePortal(document.getElementById("si-color-picker-portal"));
  const { width: windowWidth, height: windowHeight } = useWindowSize();
  const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });
  const [pickerRef, setPickerRef] = useState();

  // Save color choice if user clicks away from the picker
  useClickAway({ current: pickerRef }, onConfirm);

  useEffect(() => {
    // get the position of the bottom right of the picker and set the values for pickerPosition to them as left and top
    if (showPicker && pickerContainerRef.current) {
      const { left, top, right, width, height } =
        pickerContainerRef.current.getBoundingClientRect();
      if (pickerRef) {
        const unboundLeftOffset = left + width - PICKER_WIDTH;

        const { height: pickerHeight } = pickerRef?.getBoundingClientRect();
        const fallsBelowScreen = top + height + pickerHeight > windowHeight;
        const topOffset = fallsBelowScreen ? Math.abs(height + pickerHeight + 5) : 0;
        const leftOffset = unboundLeftOffset < 0 ? Math.abs(unboundLeftOffset) : 0;
        const newTop = top + height - topOffset;

        setPickerPosition({
          left: right - PICKER_WIDTH + 8 + leftOffset,
          top: newTop < 0 ? 0 : newTop,
        });
        setPickerVisible(true);
      }
    }
  }, [pickerContainerRef, pickerRef, showPicker, windowWidth, windowHeight]);

  return (
    <PickerPortal>
      <div
        className="si-color-picker-picker"
        ref={setPickerRef}
        style={{
          width: PICKER_WIDTH,
          opacity: pickerVisible ? 1 : 0,
          ...pickerPosition,
        }}
      >
        {children}
      </div>
    </PickerPortal>
  );
};

export default PickerModal;
